import loopMap from 'mn-utils/loopMap';
import faker from '@faker-js/faker';
import {TListItem, TTerminalDetails} from '@/api/merchant/terminals/types';

const getTerminalListItem = (): TListItem => {
  const id = faker.datatype.uuid();
  const colors = ['Dark Moon', 'Light Moon', 'Red Moon', 'Gold Moon', 'Deep Ocean'];
  const statuses = ['ordered', 'active'];
  return {
    id,
    name: faker.name.findName(),
    imei: faker.phone.imei(),
    password: faker.phone.imei(),
    status: (faker.helpers as any).arrayElement(statuses),
    color: (faker.helpers as any).arrayElement(colors),
    active: faker.datatype.boolean(),
    time_stamp: faker.date.recent().toISOString(),
    branch_name: faker.word.adjective(),
    threshold: faker.finance.amount(0, 1000, 2),
  } as TListItem;
};

export const getTerminalList = (limit: number): TListItem[] => {
  return loopMap(limit, getTerminalListItem) as TListItem[];
};

export const getTerminalDetails = (): TTerminalDetails => {
  const id = faker.datatype.uuid();
  const colors = ['Dark Moon', 'Light Moon', 'Red Moon', 'Gold Moon', 'Deep Ocean'];
  return {
    id,
    name: faker.name.findName(),
    imei: faker.phone.imei(),
    enabled: faker.datatype.boolean(),
    leasing: faker.word.adjective(),
    color: (faker.helpers as any).arrayElement(colors),
    time_stamp: faker.date.recent().toISOString(),
  } as TTerminalDetails;
};
